import axiosInstance from 'services/axios/axios';
import { catchAxiosError, then } from 'services/axios/_utility';
import { FORM_INITIAL_VALUES } from './_const';


const isImpersonationAllowed = ['development', 'test', 'demo'].includes(
	process.env.REACT_APP_IMS_ENV?.toLowerCase(),
);

/**
 * Fetches the saved challenge-response values for the challenge-response page.
 *
 * @returns {Promise<object>} form prepopulation payload.
 */
export const getChallengeResponsePrepopulation = async impersonatedUserNetworkId => {
	try {
		const isImpersonatingAnotherUser =
			isImpersonationAllowed && Boolean(impersonatedUserNetworkId);

		return axiosInstance
			.get('/api/ChallengeResponse/GetCurrent', {
				params: isImpersonatingAnotherUser
					? { impersonatedUserNetworkId }
					: {},
			})
			.then(response =>
				then(response, payload => ({
					...FORM_INITIAL_VALUES,
					challengeQuestion:
						typeof payload?.challengeQuestion === 'string'
							? payload.challengeQuestion.trim()
							: FORM_INITIAL_VALUES.challengeQuestion,
					secretAnswer:
						typeof payload?.secretAnswer === 'string'
							? payload.secretAnswer
							: FORM_INITIAL_VALUES.secretAnswer,
					validateWithChallengeResponse:
						payload?.validateWithChallengeResponse === true ||
						payload?.validateWithChallengeResponse === 'true',
				}))
			);
	} catch (error) {
		throw catchAxiosError(error);
	}
};

/**
 * Submits challenge-response updates using the dedicated challenge-response endpoint.
 *
 * @param {object} payload challenge-response form payload.
 * @returns {Promise<object>} submit payload from API.
 */
export const submitChallengeResponse = async (payload, impersonatedUserNetworkId) => {
	try {
		const isImpersonatingAnotherUser =
			isImpersonationAllowed && Boolean(impersonatedUserNetworkId);
		const requestPayload = {
			...payload,
			...(isImpersonatingAnotherUser ? { impersonatedUserNetworkId } : {}),
		};

		return axiosInstance
			.post('/api/ChallengeResponse/Submit', requestPayload)
			.then(response => then(response, responsePayload => responsePayload));
	} catch (error) {
		throw catchAxiosError(error);
	}
};